<template>
　　<Card class="ly-form" :class="{isTransparent: attrs.isTransparent}" v-if="isDisplay">
        <Row v-if="!isInit" :gutter="parseInt(attrs.gutter||0)">
            <Form ref="lyForm" :model="bindForm" :rules="formRules" :label-width="labelWidth" @keydown.native.enter.prevent="keyDownEvent">
                <template v-for="(el, i) in attrs.children" >
                <Col :span="el.span ? el.span : '8'" :key="i" v-if="!el.dataEmpty && el.isShow !== 'n'">
                    <FormItem :label="labelWidth > 0 ? el.title : ''" :prop="el.field" :key="i" v-show="el.status"> 
                        <ly-hoc :attrs="el" :page="bindForm" v-model="bindForm[el.field]" @enter="handlerEnter" @empty="handlerEmpty(i)"></ly-hoc>
                        <div class="form-tips" v-if="el.tipsTxt">{{el.tipsTxt}}</div>
                    </FormItem>
                </Col>
                </template>
                <Col span="24" v-if="attrs.isSearch || attrs.isExport || attrs.isLimitedExport">
                    <FormItem class="ly-form-buttons">
                        <Button type="primary" @click="handleGiveMeSubmitData" icon="ios-search" v-if="attrs.isSearch">搜&nbsp;索</Button>
                        <Button type="success" @click="exportFilter" ghost
                            :loading="loading"
                            icon="md-cloud-download"
                            v-if="attrs.isExport">{{attrs.exportTitle || '导出筛选结果'}}</Button>
                        <Button type="success" @click="exportLimitedFilter" ghost
                            :loading="loading"
                            icon="md-cloud-download"
                            v-if="attrs.isLimitedExport">{{attrs.limitedTitle}}</Button>
                    </FormItem>
                </Col>
                <Col span="24" v-if="attrs.isOpenLink && attrs.openUrl">
                    <FormItem class="ly-form-buttons">
                        <template v-for="(el, i) in attrs.openUrl">
                            <Button icon="md-link" type="success" v-if="attrs.isOpenLink" @click="openLink(el.value)">
                                {{el.label}}
                            </Button>&nbsp;&nbsp;
                        </template>
                    </FormItem>
                </Col>
            </Form>
        </Row>
    </Card>
</template>
<script>
    /**
     * 表单容器组件
     */
    import CompEventMixin from '@/utils/compEvent.mixin'
    import CompSendMixin from '@/utils/compSend.mixin'
    import FormMixin from '@/utils/form.mixin'
    import ExportMixin from '@/utils/export.mixin'
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    import { mapGetters } from 'Vuex'
    export default {
        name: "LyForm",
        mixins: [CompEventMixin, CompSendMixin, FormMixin, ExportMixin, CompDisplayMixin],
        data () {
            return {
                isInit: false,
                loading: false, // 标识是否在导出操作
                watchFieldVaue: {}
            }
        },
        computed: {
            ...mapGetters(['currPage', 'userInfo']),
            labelWidth () {
                let width = 120
                if (!isNaN(this.attrs.labelWidth)) {
                    width = parseInt(this.attrs.labelWidth)
                }
                return width
            }
        },
        watch: {
            /**
             * 参数变化重新初始化
             */
            attrs: {
                handler () {
                    this.initFromParams()
                },
                immediate: true
            }
        },
        methods: {
              /**
             * 初始化监听字段
             */
             initWatchField () {
                if (this.attrs.watchField) {
                    let watchArr = this.attrs.watchField.split('|')
                    for (let i = 0, len = watchArr.length; i < len; i++) {
                        let field = watchArr[i]
                        this.watchFieldVaue[field] = this.bindForm[field] 
                        this.doWatch(this.bindForm, field, 'bindForm.' + field)
                    }
                }
            },
            /**
             * 字段的监听
             */
            doWatch (obj, field, watchField) {
                this.$watch(watchField, function () {
                    this.timer && clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        let fieldValue = obj[field]
                        if (fieldValue) {
                            this.watchFieldVaue[field] = fieldValue
                            this.queryValue()
                        }
                    }, 500)
                }, {
                    deep:true
                })
            },
            /**
             * 根据监听字段获取值
             */
             queryValue () {
                if (this.attrs.api) {
                    this.isLoading = true
                    this.$api.query(this.attrs.api, this.watchFieldVaue).then(rs => {
                        this.isLoading = false
                        Object.keys(rs).forEach(key => {
                            if (this.bindForm.hasOwnProperty(key)) {
                                this.$set(this.bindForm, key, rs[key])
                            }
                        })
                        // Object.assign(this.bindForm, rs)
                    }).catch((err) => {
                        this.$Message['error']({
                            background: true,
                            content: err
                        })
                        this.isLoading = false
                    })
                }
            },
            /**
             * 初始化表单的参数
             */
            initFromParams () {
                this.isInit = true
                this.initForm(this.page)
                // 具有搜索功能，就初始化查询参数
                if (this.attrs.isSearch) {
                    this.$eventHub.$emit(this.$events.INIT_SEARCH_PARAMS, this.bindForm)
                }
                this.$nextTick(() => {
                    this.isInit = false
                    this.initWatchField()  
                })
            },
            /**
             * 获得页面数据后的回调函数，在mixin的监听中调用
             */
            pageDataCallback () {
                // 数据变化后，设置字段的值
                for (let key in this.bindForm) {
                    if (this.page.hasOwnProperty(key)) {
                        this.setFieldValue(key, this.page[key])
                    }
                }
            },
            /**
             * 有组件要提交数据的监听
             * 这里将数据验证过后，发送要提交的数据
             */
            handleGiveMeSubmitData () {
                if (!this.isDisplay) { // 增加form显示判断 by wxf 2020-11-11
                    this.$set(this.attrs, 'isSubmit', false)
                    return
                } else {
                    if (this.attrs.isSearch) { // 发送要查询的数据
                        // 2020.5.29 wxq 添加搜索条件必填验证
                        if(this.attrs.isValid){
                            if (this.$refs['lyForm'] && this.isDisplay) {
                                this.$refs['lyForm'].validate((valid) => {
                                    if (!valid) {
                                        this.$Message.error('请将信息填写完整!');
                                    } else {
                                        this.sendSearchData({
                                            ...this.bindForm,
                                            page: 1 // 设置从第一页查找
                                        })
                                    }
                                })
                            }
                        }else{
                            this.sendSearchData({
                                ...this.bindForm,
                                page: 1 // 设置从第一页查找
                            })
                        }
                    } else if (this.attrs.isSubmit) {
                        if (this.$refs['lyForm']) {
                            this.$refs['lyForm'].validate((valid) => {
                                if (!valid) {
                                    this.$Message.error('请将信息填写完整!');
                                } else {
                                    this.sendSubmitData(JSON.parse(JSON.stringify(this.bindForm)))
                                    this.bindForm = {}
                                }
                            })
                        }
                        //如果遇到异步用这个
                        //  this.doValidate().then((res) => {
                        //     if (res) {
                        //         this.sendSubmitData(this.bindForm)
                        //     }
                        // })
                        // 如果没有异步的问题用这个
                        // if (!validate)
                        //     return false
                        // // 发送需要提交的数据
                        // this.sendSubmitData(this.bindForm)
                    }
                }

            },
            /**
             * 表单重置
             */
            formReset () {
                this.$refs['lyForm'].resetFields();
            },
            /**
             * 输入框的回车时间
             */
            handlerEnter () {
                // 回车查询
                if (this.attrs.isSearch) {
                    this.handleGiveMeSubmitData()
                }
            },
            /**
             * 防止回车刷新页面
             */
            keyDownEvent () {

            },
            /**
             * 导出筛选结果
             */
            exportFilter () {
                this.exportHttp(this.attrs.exportApi, this.bindForm, null, this.attrs.exportMethod)
            },
            /**
             * 一些局限性筛选到处结果
             */
            exportLimitedFilter () {
                this.exportHttp(this.attrs.exportLimitedApi, this.bindForm)
            },
            /**
             * 2019-06-20添加，空数据事件监听，用于控制一行标题的显示
             */
            handlerEmpty (index) {
                this.$set(this.attrs.children[index], 'dataEmpty', true)
            },
            openLink (url) {
                this.$refs['lyForm'].validate((valid) => {
                    if (!valid) {
                        this.$Message.error('请将信息填写完整!');
                    } else {
                        let href =this.$path.getPath(url, this.bindForm)
                        this.$path.openNewWindow(href)
                    }
                })
                // window.open(href, '_blank');
            }
        }
    }
</script>
<style>
    .ly-form .ivu-card-body {
        padding-bottom: 0;
    }
    .ly-form .ivu-form-item {
        margin-bottom: 16px;
    }
    .ly-form .ly-form-buttons {
        text-align: center;
    }
    .ly-form .form-tips {
        font-size: 12px;
        color: #f90;
    }
    .ly-form.isTransparent {
        border: 0;
        background-color: transparent;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/form/src/index.vue